import React from 'react';
import { Link } from 'react-router-dom';
import {
  ShieldCheck, Building2, Users2, ScanLine, Rocket, HardHat, Cpu, HeartHandshake, ArrowRight,
} from 'lucide-react';
import { useLang } from '@/i18n/LanguageContext';

const AGENDA_ITEMS = [
  { key: 'zero_corruption', Icon: ShieldCheck, tone: '#138A4B' },
  { key: 'admin_reform', Icon: Building2, tone: '#062B5C' },
  { key: 'merit_leadership', Icon: Users2, tone: '#062B5C' },
  { key: 'electoral_reform', Icon: ScanLine, tone: '#138A4B' },
  { key: 'youth_employment', Icon: Rocket, tone: '#F47B20' },
  { key: 'infrastructure', Icon: HardHat, tone: '#062B5C' },
  { key: 'tech_gov', Icon: Cpu, tone: '#138A4B' },
  { key: 'citizen_first', Icon: HeartHandshake, tone: '#F47B20' },
];

export function AgendaGrid() {
  const { t } = useLang();
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
      {AGENDA_ITEMS.map(({ key, Icon, tone }) => (
        <Link
          key={key}
          to="/agenda"
          data-testid="agenda-card"
          className="group rounded-xl border border-[#D7E1EF] bg-white p-5 hover:shadow-sm hover:-translate-y-[1px] transition-shadow transition-transform block"
        >
          <div
            className="h-10 w-10 rounded-lg bg-[#F5F8FC] border border-[#D7E1EF] flex items-center justify-center"
            style={{ color: tone }}
          >
            <Icon className="h-5 w-5" />
          </div>
          <div className="mt-4 font-semibold text-[#0B1220]">{t(`agenda.items.${key}.title`)}</div>
          <div className="mt-2 text-sm text-[#5B6B82] leading-relaxed">{t(`agenda.items.${key}.desc`)}</div>
          <div
            data-testid="agenda-card-link"
            className="mt-4 inline-flex items-center text-sm font-medium text-[#062B5C] group-hover:text-[#05244d]"
          >
            {t('common.view_details')} <ArrowRight className="ml-1 h-4 w-4" />
          </div>
        </Link>
      ))}
    </div>
  );
}
